import  { useCallback } from "react";
import { useDispatch } from "react-redux";
import { singletonHook } from 'react-singleton-hook';
import * as AuthActions from "../redux/actions/AuthAction";
import * as qs from 'qs';

let authData = {data: {}, actions: {}}
const useAuthServicesFn = ()=>{ 
    
    const dispatchAuth = useDispatch();
    const GetToken = useCallback(async () => {   
        let location = window.location;
        const searchParam = qs.parse(location.search, { ignoreQueryPrefix: true });
        if(searchParam.username) {
            var userName = searchParam.username.replace('/','');
            localStorage.setItem('username', userName);
            var action = await AuthActions.GetToken(userName);
            dispatchAuth(action);        
        }  

    }, [dispatchAuth])

    authData = {data: null, actions:{GetToken}}

   
    return authData
}

export const useAuthServices = singletonHook(authData, useAuthServicesFn);;